const coreStore = {
  namespaced: true,
  state: {
    isLong: true,
  },
  getters: {
    GT_IS_LONG: (state) => state.isLong,
    GT_POSITION_TYPE: (state) => (state.isLong ? "long" : "short"),
  },
  mutations: {
    MU_UPDATE_TYPE: (state, payload) => {
      state.isLong = payload === "long";
    },
  },
};

export default coreStore;
